import React from "react";
import { Helmet } from "react-helmet";
import {FaMagic, FaCut, FaImage } from 'react-icons/fa';

const features = [
  {
    icon: <FaMagic className="text-4xl text-teal-500" />,
    title: "AI-Powered Transformation",
    description: "Experience the magic of AI as it transforms your photos with stunning new hairstyles in seconds."
  },
  {
    icon: <FaCut className="text-4xl text-teal-500" />,
    title: "Extensive Style Collection",
    description: "Choose from hundreds of trendy hairstyles for both men and women, or upload your own reference."
  },
  {
    icon: <FaImage className="text-4xl text-teal-500" />,
    title: "Realistic Results",
    description: "Our advanced AI ensures natural-looking results that match your facial features perfectly."
  }
];

const WebApplicationSchema = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "AI Hairstyle Studio",
    "description": "Virtual hair salon powered by AI for trying on different hairstyles and haircuts",
    "applicationCategory": "Beauty & Lifestyle",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "featureList": features.map(f => f.title).join(", ")
  };

  return (
    <Helmet>
      <title>AI Hairstyle Studio - Virtual Hair Salon & Style Transformation</title>
      <meta
        name="description"
        content="Transform your look with AI Hairstyle Studio's virtual hair salon. Try on different hairstyles, explore haircuts, and experiment with colors instantly using AI technology."
      />
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default WebApplicationSchema;
